import * as React from "react"

function SvgCheckBoxDisabledV2(props) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M19.1667 21.5H2.83333C1.55 21.5 0.5 20.45 0.5 19.1667V2.83333C0.5 1.55 1.55 0.5 2.83333 0.5H19.1667C20.45 0.5 21.5 1.55 21.5 2.83333V19.1667C21.5 20.45 20.45 21.5 19.1667 21.5Z"
        fill="#999999"
      />
    </svg>
  )
}

export default SvgCheckBoxDisabledV2
